
import hanson from 'hanson';

export default function loadJsonFromText(text, callback) {

    let error;
    let result;

    try {
        result = hanson.parse(text);
    } catch (e) {
        console.error('Parse error.', text);
        console.error(e);
        error = e;
    }
    callback(error, result);
}
